import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';

import { MatToolbarModule } from '@angular/material/toolbar';
import { AgrPageToolbarModule, AgrFilterModule } from '@next/core-lib/components';

import { AgrDialogModule } from '@next/core-lib/dialog';
import { AgrFormModule } from '@next/core-lib/form';
import { provideEffects } from '@ngrx/effects';

import { provideState } from '@ngrx/store';

import { ProprietaryFertilizersOverviewComponent } from './proprietary-fertilizers-overview.component';
import { SharedModule } from '../shared/shared.module';

import { ProprietaryFertilizersOverviewEffects } from './store/proprietary-fertilizers-overview.effects';

/* eslint-disable-next-line max-len */
import { ProprietaryFertilizerDialogComponent } from '../proprietary-fertilizer/components/proprietary-fertilizer-dialog/proprietary-fertilizer-dialog.component';

import { ProprietaryFertilizerEffects } from '../proprietary-fertilizer/store/proprietary-fertilizer.effects';
import { proprietaryFertilizerReducer } from '../proprietary-fertilizer/store/proprietary-fertilizer.reducer';

@NgModule({
  declarations: [ProprietaryFertilizersOverviewComponent, ProprietaryFertilizerDialogComponent],
  imports: [
    CommonModule,
    FormsModule,
    MatTableModule,
    MatIconModule,
    MatPaginatorModule,
    MatToolbarModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    AgrFormModule,
    AgrDialogModule,
    SharedModule,
    AgrPageToolbarModule,
    MatAutocompleteModule,
    AgrFilterModule,
  ],
  providers: [
    provideState('proprietaryFertilizer', proprietaryFertilizerReducer),
    provideEffects(ProprietaryFertilizersOverviewEffects, ProprietaryFertilizerEffects),
  ],
})
export class ProprietaryFertilizersOverviewModule {}
